import React, { ReactNode, useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { dashboardPagesMenu, getModulesArray } from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import Hand from '../../../assets/img/hand.png';
import HandWebp from '../../../assets/img/hand.webp';
import Button from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import AuthContext from '../../../contexts/authContext';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const [doc, setDoc] = useState(localStorage.getItem('facit_asideDocStatus') === 'true' || false);
	const [allModules, setAllModules] = useState(getModulesArray());
	const [newDashboardPagesMenu, setNewDashboardPagesMenu] = useState({});
	const [superAdminMenu, setSuperAdminMenu] = useState({});
	var modulesData: any = {};
	const { t } = useTranslation(['translation', 'menu']);
	const { darkModeStatus } = useDarkMode();
	const { updateSidebar, setUpdateSidebar } = useContext(AuthContext);
	var userAccessList: any = [];

	const [isCompleted, setIsCompleted] = useState(false);

	interface SubMenu {
		[key: string]: {
			id: string;
			stageNo: string;
			text: string;
			path: string;
			icon: string;
			count: number;
		};
	}
	interface DtrmMenu {
		dtrm_stage: {
			id: string;
			text: string;
			path: string;
			icon: string;
			subMenu: SubMenu;
		};
	}

	interface RepairDtrmMenu {
		dtrm_stage: {
			id: string;
			text: string;
			path: string;
			icon: string;
			subMenu: SubMenu;
		};
	}
	interface RepairDtrmPaPcMenu {
		dtrm_stage: {
			id: string;
			text: string;
			path: string;
			icon: string;
			subMenu: SubMenu;
		};
	}

	interface DynamicMainMenu {
		id: string;
		text: string;
		path: string;
		icon: string;
		hide: boolean;
		subMenu: SubMenu;
	}

	interface newMenu {
		[key: string]: {
			id: string;
			text: string;
			path: string;
			icon: string;
			hide: boolean;
			subMenu: newSubMenu;
		};
	}
	interface newSubMenu {
		[key: string]: {
			id: string;
			text: string;
			path: string;
			icon: string;
			hide: boolean;
		};
	}

	useEffect(() => {
		if (localStorage.getItem('userData') != '' && localStorage.getItem('userData') != null) {
			var localData = JSON.parse(localStorage.getItem('userData') || '');
			if (
				localData.designation.name == 'SuperAdmin' ||
				localData.designation.name == 'superadmin' ||
				localData.designation.name == 'Super Admin'
			) {
				const superAdminFiltered = Object.values(dashboardPagesMenu).reduce(
					(acc: any, module: any) => {
						// Always remove original Tool Customization
						if (module.id === 'toolCustomization') {
							return acc;
						}

						acc[module.id] = module;
						return acc;
					},
					{}
				);

				setSuperAdminMenu(superAdminFiltered);
				// fetchJobOrderData();
			} else {
				// fetchMaintenanceData();
				getUserAccess().then((_) => {
					setNewDashboardPagesMenu(modulesData);
					// fetchJobOrderData();
				});
			}
		}
	}, []);

	// useEffect(() => {
	// 	if (updateSidebar) {
	// 		if (localStorage.getItem('userData') != '' && localStorage.getItem('userData') != null) {
	// 			var localData = JSON.parse(localStorage.getItem('userData') || '');
	// 			if (
	// 				localData.designation.name == 'SuperAdmin' ||
	// 				localData.designation.name == 'superadmin' ||
	// 				localData.designation.name == 'Super Admin'
	// 			) {
	// 				setSuperAdminMenu(dashboardPagesMenu);
	// 				fetchJobOrderData();
	// 			} else {
	// 				// fetchMaintenanceData();
	// 				getUserAccess().then((_) => {
	// 					setNewDashboardPagesMenu(modulesData);
	// 					fetchJobOrderData();
	// 				});
	// 			}
	// 		}

	// 		setUpdateSidebar?.(false);
	// 	}
	// }, [updateSidebar]);

	// const fetchMaintenanceData = async () => {
	// 	interface newMenu1 {
	// 		[key: string]: {
	// 			id: string;
	// 			text: string;
	// 			path: string;
	// 			icon: string;
	// 			hide: boolean;
	// 			subMenu: newSubMenu1[];
	// 		};
	// 	}
	// 	interface newSubMenu1 {
	// 		id: string;
	// 		text: string;
	// 		path: string;
	// 		icon: string;
	// 		hide: boolean;
	// 	}

	// 	interface SubMenu1 {
	// 		id: string;
	// 		stageNo: string;
	// 		text: string;
	// 		path: string;
	// 		icon: string;
	// 		count: number;
	// 		hide: boolean;
	// 	}
	// 	interface DtrmMenu1 {
	// 		dtrm_stage: {
	// 			id: string;
	// 			text: string;
	// 			path: string;
	// 			icon: string;
	// 			hide: boolean;
	// 			subMenu: SubMenu1[];
	// 		};
	// 	}
	// 	interface RepairDtrmMenu1 {
	// 		dtrm_stage: {
	// 			id: string;
	// 			text: string;
	// 			path: string;
	// 			icon: string;
	// 			hide: boolean;
	// 			subMenu: SubMenu1[];
	// 		};
	// 	}
	// 	interface RepairDtrmPaPcMenu1 {
	// 		dtrm_stage: {
	// 			id: string;
	// 			text: string;
	// 			path: string;
	// 			icon: string;
	// 			hide: boolean;
	// 			subMenu: SubMenu1[];
	// 		};
	// 	}

	// 	try {
	// 		const response = await fetch(`${process.env.REACT_APP_NODEJS_URL}maintenance/dropdown_maintenance`, {
	// 			method: 'GET',
	// 			headers: { 'Content-Type': 'application/json' },
	// 		});
	// 		const result = await response.json();

	// 		let job_order_menu: newMenu1 = {
	// 			job_order_dynamic: {
	// 				id: 'job_order_dynamic',
	// 				text: 'Job Order ',
	// 				path: '/',
	// 				icon: 'BatchPrediction',
	// 				hide: false,
	// 				subMenu: [],
	// 			},
	// 		};

	// 		result.data?.forEach(async (item: any, index: number) => {
	// 			job_order_menu.job_order_dynamic.subMenu.push(
	// 				{
	// 					id: 'transfer_inventory_' + item.name,
	// 					text: 'Inventory Transfer - ' + item.name,
	// 					path: `transfer_inventory/${item.id}`,
	// 					icon: 'LocalShipping',
	// 					hide: false,
	// 				},
	// 				{
	// 					id: 'job_order_' + item.name,
	// 					text: 'Job Order - ' + item.name,
	// 					path: `job_order/${item.id}`,
	// 					icon: 'BatchPrediction',
	// 					hide: false,
	// 				},
	// 				{
	// 					id: 'job_initiation_' + item.name,
	// 					text: 'Job Initiation - ' + item.name,
	// 					path: `job_initiation/${item.id}`,
	// 					icon: 'PlayCircleOutline',
	// 					hide: false,
	// 				},
	// 			);
	// 		});

	// 		if (result.data.length > 0) {
	// 			var menu = Object.values(job_order_menu.job_order_dynamic.subMenu);
	// 			job_order_menu.job_order_dynamic.subMenu = menu;
	// 			const updatedAllModules = allModules.filter((item) => item.id !== 'job_orders');
	// 			const index = updatedAllModules.findIndex((item) => item.id === 'kiosk_dashboard');
	// 			if (index !== -1) {
	// 				updatedAllModules.splice(index + 1, 0, job_order_menu.job_order_dynamic);
	// 			}
	// 			var localData = JSON.parse(localStorage.getItem('userData') || '');

	// 			if (
	// 				localData.designation.name == 'SuperAdmin' ||
	// 				localData.designation.name == 'superadmin' ||
	// 				localData.designation.name == 'Super Admin'
	// 			) {
	// 				await Promise.all(
	// 					result?.data?.map(async (menu: any, newindex: any) => {
	// 						let mainMenu: any = {
	// 							id: menu?.name.toLowerCase().replace(/ /g, '_'),
	// 							text: menu?.name,
	// 							path: '/',
	// 							icon: 'Timeline',
	// 							subMenu: [],
	// 						};

	// 						const newresponse = await fetch(process.env.REACT_APP_NODEJS_URL + 'job_orders/get_stage_list_as_per_maintenance_line', {
	// 							method: 'POST',
	// 							headers: {
	// 								'Content-Type': 'application/json',
	// 							},
	// 							body: JSON.stringify({
	// 								maintenance_line_id: menu.id,
	// 								type: localData.designation.name,
	// 							}),
	// 						});
	// 						const filter_data = await newresponse.json();
	// 						filter_data.data.forEach((item: any, index: number) => {
	// 							mainMenu.subMenu.push({
	// 								id: `stage${index + 1}`,
	// 								stageNo: `Stage ${item.stage_number}`,
	// 								text: item.name,
	// 								path: `/job_stage_maintenance/${item.id}/${menu.id}`,
	// 								icon: 'FiberManualRecord',
	// 								count: item.count,
	// 							});
	// 						});

	// 						const dynamicIndex = updatedAllModules.findIndex((module) => module.id == 'job_order_dynamic');
	// 						if (dynamicIndex !== -1) {
	// 							updatedAllModules.splice(dynamicIndex + 1, 0, mainMenu);
	// 						}
	// 					}),
	// 				);
	// 			} else {
	// 				await Promise.all(
	// 					result?.data?.map(async (menu: any, newindex: any) => {
	// 						let mainMenu: any = {
	// 							id: menu?.name.toLowerCase().replace(/ /g, '_'),
	// 							text: menu?.name,
	// 							path: '/',
	// 							icon: 'Timeline',
	// 							subMenu: [],
	// 						};

	// 						const newresponse = await fetch(process.env.REACT_APP_NODEJS_URL + 'job_orders/get_stage_list_as_per_maintenance_line', {
	// 							method: 'POST',
	// 							headers: {
	// 								'Content-Type': 'application/json',
	// 							},
	// 							body: JSON.stringify({
	// 								maintenance_line_id: menu.id,
	// 								designation_id: localData?.designation?.id,
	// 								operator_id: localData.id,
	// 							}),
	// 						});
	// 						const filter_data = await newresponse.json();

	// 						filter_data.data.forEach((item: any, index: number) => {
	// 							mainMenu.subMenu.push({
	// 								id: `stage${index + 1}`,
	// 								stageNo: `Stage ${item.stage_number}`,
	// 								text: item.name,
	// 								path: `/job_stage_maintenance/${item.id}/${menu.id}`,
	// 								icon: 'FiberManualRecord',
	// 								count: item.count,
	// 							});
	// 						});

	// 						const dynamicIndex = updatedAllModules.findIndex((module) => module.id == 'job_order_dynamic');
	// 						if (dynamicIndex !== -1) {
	// 							updatedAllModules.splice(dynamicIndex + 1, 0, mainMenu);
	// 						}
	// 					}),
	// 				);
	// 			}

	// 			for (let i = 0; i < updatedAllModules.length; i++) {
	// 				const module = updatedAllModules[i] as any;
	// 				if (module.text === 'Dashboard') {
	// 					module.hide = false;
	// 					module.subMenu = null;
	// 				} else if (module.text === 'Kiosk Dashboard') {
	// 					module.hide = false;
	// 					module.subMenu = null;
	// 				} else if (module.text === 'Job Orders') {
	// 					module.hide = false;
	// 				} else if (module.text === 'User Access Rights') {
	// 					const isModuleInData = userAccessList.some((item: any) => item.module_name === module.path);
	// 					module.hide = !isModuleInData;

	// 					if (module.subMenu.length > 0 && module.subMenu && Array.isArray(module.subMenu)) {
	// 						if (module.id == 'job_order_dynamic') {
	// 							for (let j = 0; j < module.subMenu.length; j++) {
	// 								const subModule = module.subMenu[j] as any;
	// 								const isSubModuleInData = userAccessList.some((item: any) => item.module_name === subModule.path);
	// 								subModule.hide = !isSubModuleInData;
	// 							}
	// 						}
	// 					} else {
	// 						module.subMenu = null;
	// 					}
	// 				} else {
	// 					const isModuleInData = userAccessList.some((item: any) => item.module_name === module.id);
	// 					module.hide = !isModuleInData;
	// 					if (module.subMenu.length > 0 && module.subMenu && Array.isArray(module.subMenu)) {
	// 						if (module.id == 'job_order_dynamic') {
	// 							for (let j = 0; j < module.subMenu.length; j++) {
	// 								const subModule = module.subMenu[j] as any;
	// 								const isSubModuleInData = userAccessList.some((item: any) => item.module_name === subModule.path);
	// 								subModule.hide = !isSubModuleInData;
	// 							}
	// 						}
	// 					} else {
	// 						module.subMenu = null;
	// 					}
	// 				}
	// 			}
	// 			let updatedAllModules1: any;
	// 			let updatedAllModules2: any;

	// 			for (let i = 0; i < updatedAllModules.length; i++) {
	// 				const module = updatedAllModules[i] as any;
	// 				if (module.id == 'job_order_dynamic') {
	// 					let list = [];
	// 					for (let j = 0; j < module.subMenu.length; j++) {
	// 						if (module.subMenu[j].hide == true) {
	// 							list.push(module.subMenu[j]);

	// 							if (list.length == module.subMenu.length) {
	// 								if (module.id == 'job_order_dynamic') {
	// 									updatedAllModules1 = updatedAllModules.filter((item) => item.id !== 'job_order_dynamic');
	// 									setNewDashboardPagesMenu(updatedAllModules1);
	// 								}
	// 							}
	// 						}
	// 						if (module.subMenu.length == j + 1 && list.length != module.subMenu.length) {
	// 							setNewDashboardPagesMenu(updatedAllModules);
	// 						}
	// 					}
	// 				}

	// 				if (module.id == 'toolCustomization') {
	// 					let list = [];
	// 					for (let j = 0; j < module.subMenu.length; j++) {
	// 						if (module.subMenu[j].hide == true) {
	// 							list.push(module.subMenu[j]);
	// 							if (list.length == module.subMenu.length) {
	// 								if (module.id == 'toolCustomization' && updatedAllModules1 == undefined) {
	// 									updatedAllModules1 = updatedAllModules.filter((item: any) => item.id !== 'toolCustomization');
	// 									setNewDashboardPagesMenu(updatedAllModules1);
	// 								}
	// 								if (module.id == 'toolCustomization' && updatedAllModules1 != undefined) {
	// 									updatedAllModules2 = updatedAllModules1.filter((item: any) => item.id !== 'toolCustomization');
	// 									setNewDashboardPagesMenu(updatedAllModules2);
	// 								}
	// 							}
	// 						} else {
	// 							if (module.id == 'toolCustomization' && updatedAllModules1 != undefined) {
	// 								setNewDashboardPagesMenu(updatedAllModules1);
	// 							} else {
	// 								setNewDashboardPagesMenu(updatedAllModules);
	// 							}
	// 						}
	// 					}
	// 				}

	// 				if (module.id == 'report') {
	// 					let list = [];
	// 					for (let j = 0; j < module.subMenu.length; j++) {
	// 						if (module.subMenu[j].hide == true) {
	// 							list.push(module.subMenu[j]);
	// 							if (list.length == module.subMenu.length) {
	// 								if (
	// 									module.id == 'report' &&
	// 									updatedAllModules1 == undefined
	// 								) {
	// 									updatedAllModules1 = updatedAllModules.filter(
	// 										(item: any) => item.id !== 'report',
	// 									);
	// 									setNewDashboardPagesMenu(updatedAllModules1);
	// 								}
	// 								if (
	// 									module.id == 'report' &&
	// 									updatedAllModules1 != undefined
	// 								) {
	// 									updatedAllModules2 = updatedAllModules1.filter(
	// 										(item: any) => item.id !== 'report',
	// 									);
	// 									setNewDashboardPagesMenu(updatedAllModules2);
	// 								}
	// 							}
	// 						} else {
	// 							if (
	// 								module.id == 'report' &&
	// 								updatedAllModules1 != undefined
	// 							) {
	// 								setNewDashboardPagesMenu(updatedAllModules1);
	// 							} else {
	// 								setNewDashboardPagesMenu(updatedAllModules);
	// 							}
	// 						}
	// 					}
	// 				}
	// 			}
	// 		}
	// 	} catch (error) {
	// 		console.error('error : ', error);
	// 	}
	// };

	const getUserAccess = async () => {
		var localData = JSON.parse(localStorage.getItem('userData') || '');

		try {
			await fetch(`${process.env.REACT_APP_NODEJS_URL}permissions/get_permissions_data`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					// branch: localData.branch.id,
					company: localData.company.id,
					division: localData.division.id,
					designation: localData.designation.id,
				}),
			}).then(async (response) => {
				const result = await response.json();

				userAccessList = result.data;

				// for (let i = 0; i < allModules.length; i++) {
				// 	const module = allModules[i] as any;
				// 	if (module.text === 'Home') {
				// 		module.hide = false;
				// 	} else {
				// 		const isModuleInData = result.data.some((item: any) => item.module_name === module.path);
				// 		module.hide = !isModuleInData;

				// 		if (module.subMenu && Array.isArray(module.subMenu)) {
				// 			for (let j = 0; j < module.subMenu.length; j++) {
				// 				const subModule = module.subMenu[j] as any;
				// 				const isSubModuleInData = result.data.some((item: any) => item.module_name === subModule.path);
				// 				subModule.hide = !isSubModuleInData;
				// 			}
				// 		}
				// 	}
				// }
				for (let i = 0; i < allModules.length; i++) {
					const module = allModules[i] as any;

					if (module.text === 'Home') {
						module.hide = false;
						continue;
					}

					// 🔹 HANDLE ORIGINAL TOOL CUSTOMIZATION
					if (module.id === 'toolCustomization') {

						let hasSubMenuAccess = false;

						if (module.subMenu && Array.isArray(module.subMenu)) {
							for (let j = 0; j < module.subMenu.length; j++) {
								const subModule = module.subMenu[j];

								const isSubModuleInData = result.data.some(
									(item: any) => item.module_name === subModule.path
								);

								subModule.hide = !isSubModuleInData;

								if (isSubModuleInData) {
									hasSubMenuAccess = true;
								}
							}
						}

						// Always hide original
						module.hide = true;

						// 🔹 Now manually control ToolCustomizationMain
						const toolMain = allModules.find(
							(m: any) => m.id === 'toolCustomizationMain'
						);

						if (toolMain) {
							toolMain.hide = !hasSubMenuAccess;
						}

						continue;
					}

					// 🔹 Skip permission check for ToolCustomizationMain
					if (module.id === 'toolCustomizationMain') {
						continue;
					}

					// 🔹 Normal modules
					const isModuleInData = result.data.some(
						(item: any) => item.module_name === module.path
					);

					module.hide = !isModuleInData;

					if (module.subMenu && Array.isArray(module.subMenu)) {
						for (let j = 0; j < module.subMenu.length; j++) {
							const subModule = module.subMenu[j];

							const isSubModuleInData = result.data.some(
								(item: any) => item.module_name === subModule.path
							);

							subModule.hide = !isSubModuleInData;
						}
					}
				}

				const filteredModules = allModules.filter((module) => {
					if (module.id === 'toolCustomization') {
						return false;
					}
					if (module.hide) {
						const allSubmenusHidden =
							module.subMenu && Array.isArray(module.subMenu) && module.subMenu.every((subModule: { hide: any }) => subModule.hide);
						return !allSubmenusHidden;
					}
					return true;
				});

				const allModulesObject = filteredModules.reduce((acc: any, module: any) => {
					const key = module.id || module.path;

					acc[key] = {
						...module,
						subMenu:
							module.subMenu && module.subMenu.length > 0
								? module.subMenu.reduce((subAcc: any, subModule: any) => {
										const subKey = subModule.id || subModule.path;
										subAcc[subKey] = subModule;
										return subAcc;
									}, {})
								: null,
					};

					return acc;
				}, {});
				modulesData = allModulesObject;
				setNewDashboardPagesMenu(allModulesObject);
			});
		} catch (error) {
			console.error('error : ', error);
		}
	};

	// const fetchJobOrderData = async () => {
	// 	if (localStorage.getItem('userData') != '' && localStorage.getItem('userData') != null) {
	// 		var localData = JSON.parse(localStorage.getItem('userData') || '');

	// 		try {
	// 			const response = await fetch(`${process.env.REACT_APP_NODEJS_URL}maintenance/dropdown_maintenance`, {
	// 				method: 'GET',
	// 				headers: { 'Content-Type': 'application/json' },
	// 			});
	// 			const result = await response.json();

	// 			let job_order_menu: newMenu = {
	// 				job_order_dynamic: {
	// 					id: 'job_order_dynamic',
	// 					text: 'Job Order ',
	// 					path: '/',
	// 					icon: 'BatchPrediction',
	// 					hide: false,
	// 					subMenu: {},
	// 				},
	// 			};

	// 			result.data.forEach((item: any, index: number) => {
	// 				job_order_menu.job_order_dynamic.subMenu['transfer_inventory_' + item.name] = {
	// 					id: 'transfer_inventory_' + item.name,
	// 					text: 'Inventory Transfer - ' + item.name,
	// 					path: `transfer_inventory/${item.id}`,
	// 					icon: 'LocalShipping',
	// 					hide: false,
	// 				};
	// 				job_order_menu.job_order_dynamic.subMenu['job_order_' + item.name] = {
	// 					id: 'job_order_' + item.name,
	// 					text: 'Job Order - ' + item.name,
	// 					path: `job_order/${item.id}`,
	// 					icon: 'BatchPrediction',
	// 					hide: false,
	// 				};
	// 				job_order_menu.job_order_dynamic.subMenu['job_initiation_' + item.name] = {
	// 					id: 'job_initiation_' + item.name,
	// 					text: 'Job Initiation - ' + item.name,
	// 					path: `job_initiation/${item.id}`,
	// 					icon: 'PlayCircleOutline',
	// 					hide: false,
	// 				};
	// 			});

	// 			if (result.data.length > 0) {
	// 				if (
	// 					localData.designation.name == 'SuperAdmin' ||
	// 					localData.designation.name == 'superadmin' ||
	// 					localData.designation.name == 'Super Admin'
	// 				) {
	// 					const updatedMenu = addMenuItem(dashboardPagesMenu, job_order_menu.job_order_dynamic, 'kiosk_dashboard');
	// 					setSuperAdminMenu(updatedMenu);
	// 					fetchStageData(updatedMenu);
	// 				} else {
	// 					const updatedMenu = addMenuItem(modulesData, job_order_menu.job_order_dynamic, 'kiosk_dashboard');
	// 					setNewDashboardPagesMenu(updatedMenu);
	// 					fetchStageData(updatedMenu);
	// 				}
	// 			}
	// 		} catch (error) {
	// 			console.error('Error fetching data:', error);
	// 		}
	// 	}
	// };


	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				{!doc && (
					<>
						<Navigation
							menu={superAdminMenu && Object.keys(superAdminMenu).length > 0 ? superAdminMenu : newDashboardPagesMenu}
							id='aside-dashboard'
						/>
					</>
				)}
				{asideStatus && doc && (
					<Card className='m-3 '>
						<CardBody className='pt-0'>
							<img srcSet={HandWebp} src={Hand} alt='Hand' width={130} height={130} />
							<p
								className={classNames('h4', {
									'text-dark': !darkModeStatus,
									'text-light': darkModeStatus,
								})}>
								{t('Everything is ready!') as ReactNode}
							</p>
							<Button
								color='info'
								isLight
								className='w-100'
								onClick={() => {
									localStorage.setItem('facit_asideDocStatus', 'false');
									setDoc(false);
								}}>
								{t('Demo Pages') as ReactNode}
							</Button>
						</CardBody>
					</Card>
				)}
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
